export const apiKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDY4YzllNUVlYjg0OWY3NUNkQzdjMzhjOTUzYjEwYTVDZUIyRTU5Y0IiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYzMzIzNjg3MTE0MSwibmFtZSI6InR1dG9yaWFsZXRncmFtIn0.KqYefQUse5uVRmgCJcPuZeYrWvk5iY7MyJMW5o0X804'
